import { ICell } from 'models/interfaces/spreadsheet-types/core-types';

/* eslint-disable no-param-reassign */
const disableSecuritySelectionCell = (cell: ICell) => {
  cell.readOnly = true;
  cell.tooltipMessages = [
    'Security can\'t be changed with existing ownership. Delete this column to add ownership for a different security',
  ];
  cell.tooltipPlacement = 'bottom';
};

export default disableSecuritySelectionCell;
